<template>
  <div class="page-container flex-mid">
    <div class="center">
      <div class="text-header">{{ $t('sso.mobile_welcome_to') }}</div>
      <div class="text-header">Happily × {{ "Pomelo" }}</div>
      <div class="text-body">{{ $t('sso.mobile_account_set_to_login') }}</div>
      <div class="loading">
        <div id="wrapper">
          <div class="profile-main-loader">
            <div class="loader">
              <svg class="circular-loader" viewBox="25 25 50 50">
                <circle
                  class="loader-path"
                  cx="50"
                  cy="50"
                  r="20"
                  fill="none"
                  stroke="#FFC75F"
                  stroke-width="6"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
export default {
  name: "ssoMobile",
  mounted() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const provider = new firebase.auth.SAMLAuthProvider(
      "saml.linecorp" // !!!!!PUT YOUR PROVIDER ID HERE!!!!!
    );
    if (params["type"] === "saml-authenticate") {
      // Are we logging a user in?
      if (this.getCookie("redirecting") === "true") {
        // Has firebase redirected back here from an SSO page?
        this.setCookie("redirecting", "false", 5); // Reset the redirect cookie in case the user comes back withing 5 minutes (cookie expiration)
        firebase
          .auth()
          .getRedirectResult()
          .then(
            async (result) => {
              if (result.credential && result.user) {
                let credential = result.credential;
                const user = result.user;
                let credentialJSON = JSON.stringify(credential.toJSON()); // Conver the auth token into a string so it can be passed back
                await firebase
                  .database()
                  .ref("loginsso/" + params["id"])
                  .update({
                    credential: credentialJSON,
                    user: JSON.stringify(user),
                  });
                alert(params["linkingUri"]);
                window.location.href = params["linkingUri"];
                // window.location.href =
                //   params["linkingUri"] + "?credential=" + credentialJSON+'&user='+JSON.stringify(user); // Redirect back to the app
              }
            },
            function (error) {
              alert(
                "Error with authenticating!\n" +
                  "Code:" +
                  error.code +
                  "\n" +
                  error
              );
            }
          );
      } else {
        this.setCookie("redirecting", "true", 5); // Remember that it is a redirect once the user signs in
        firebase.auth().signInWithRedirect(provider); // Go to the sign in page
      }
    } else if (params["linkingUri"].includes("saml-reauthenticate")) {
      // Are we reauthenticating?
      //TODO: find a way to implement
    } else if (params["linkingUri"].includes("saml-link")) {
      // Are we linking an existing user to a SAML SSO?
      //TODO: find a way to implement
    }
  },
  methods: {
    setCookie(cName, cValue, expMinutes) {
      let date = new Date();
      date.setTime(date.getTime() + expMinutes * 60 * 1000);
      const expires = "expires=" + date.toUTCString();
      document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
    },
    getCookie(cName) {
      const name = cName + "=";
      const cDecoded = decodeURIComponent(document.cookie); //to be careful
      const cArr = cDecoded.split("; ");
      let res;
      cArr.forEach((val) => {
        if (val.indexOf(name) === 0) res = val.substring(name.length);
      });
      return res;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  width: 100vw;
  height: 100vh;
  background-color: #5f32a7;
  font-family: Lato, 'Kanit', Arial, sans-serif;
  .text-header {
    font-size: 24px;
    font-weight: 700;
    color: #ffffff;
  }
  .text-body {
    margin-top: 100px;
    font-size: 17px;
    color: #ffc75f;
  }
  .loading {
    margin-top: 52px;
  }
}

#wrapper {
  position: relative;
  /*background:#333;*/
  height: 100%;
}

.profile-main-loader .loader {
  position: relative;
  margin: 0px auto;
  width: 47px;
  height: 47px;
}
.profile-main-loader .loader:before {
  content: "";
  display: block;
  padding-top: 100%;
}

.circular-loader {
  -webkit-animation: rotate 2s linear infinite;
  animation: rotate 2s linear infinite;
  height: 100%;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
  transform-origin: center center;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  margin: auto;
}

.loader-path {
  stroke-dasharray: 150, 200;
  stroke-dashoffset: -10;
  animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
  stroke-linecap: round;
}

@-webkit-keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124;
  }
}
@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124;
  }
}
@-webkit-keyframes color {
  0% {
    stroke: #70c542;
  }
  40% {
    stroke: #70c542;
  }
  66% {
    stroke: #70c542;
  }
  80%,
  90% {
    stroke: #70c542;
  }
}
@keyframes color {
  0% {
    stroke: #70c542;
  }
  40% {
    stroke: #70c542;
  }
  66% {
    stroke: #70c542;
  }
  80%,
  90% {
    stroke: #70c542;
  }
}
</style>